import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = { class: "taxt-base font-bold mb-3" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-5 border-grey-6 p-3 rounded-lg" }
const _hoisted_4 = { class: "mb-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "taxt-base font-bold mb-3" }, "Trayek Lama", -1)
const _hoisted_6 = { class: "grid grid-cols-7 items-center pl-4" }
const _hoisted_7 = { class: "col-span-3 break-words" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "mx-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-right" })
], -1)
const _hoisted_9 = { class: "col-span-3 break-words" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "taxt-base font-bold mb-3" }, "Jam Keberangkatan PP", -1)
const _hoisted_12 = { class: "grid grid-cols-7 pl-4" }
const _hoisted_13 = { class: "col-span-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "mx-3 my-auto w-1/7" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-right" })
], -1)
const _hoisted_15 = { class: "col-span-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "taxt-base font-bold mb-3" }, "Kelas", -1)
const _hoisted_17 = { class: "grid grid-cols-7 items-center pl-4" }
const _hoisted_18 = { class: "col-span-3 break-words" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "mx-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-right" })
], -1)
const _hoisted_20 = { class: "col-span-3 break-words" }
const _hoisted_21 = { class: "mb-5" }
const _hoisted_22 = { class: "taxt-base font-bold mb-3" }
const _hoisted_23 = { class: "grid md:grid-cols-2 gap-4 border-grey-6 p-3 rounded-lg" }
const _hoisted_24 = { class: "mb-5" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "taxt-base font-bold mb-3" }, "Trayek Lama", -1)
const _hoisted_26 = { class: "grid grid-cols-7 items-center pl-4" }
const _hoisted_27 = { class: "col-span-3 break-words" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "mx-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-right" })
], -1)
const _hoisted_29 = { class: "col-span-3 break-words" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "taxt-base font-bold mb-3" }, "Jam Keberangkatan PP", -1)
const _hoisted_32 = { class: "grid grid-cols-7 pl-4" }
const _hoisted_33 = { class: "col-span-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "mx-3 my-auto w-1/7" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-right" })
], -1)
const _hoisted_35 = { class: "col-span-3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "taxt-base font-bold mb-3" }, "Kelas", -1)
const _hoisted_37 = { class: "grid grid-cols-7 items-center pl-4" }
const _hoisted_38 = { class: "col-span-3 break-words" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "mx-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-right" })
], -1)
const _hoisted_40 = { class: "col-span-3 break-words" }
const _hoisted_41 = { class: "mb-4" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold mb-3" }, "Alasan Mutasi", -1)
const _hoisted_43 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_44 = { class: "w-full mb-3 md:w-1/4 md:mb-0" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_46 = { class: "w-full mb-3 md:w-3/4 md:mb-0" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Simpan Mutasi Bus")
const _hoisted_48 = { class: "container-img" }
const _hoisted_49 = ["src"]
const _hoisted_50 = { class: "title" }
const _hoisted_51 = { class: "sub-title" }
const _hoisted_52 = { class: "container-btn-action" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Kembali")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_HjpModalDefault = _resolveComponent("HjpModalDefault")!
  const _component_ConfirmModal2 = _resolveComponent("ConfirmModal2")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.mutationReview.firstBus.Nopol), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.mutationReview.firstBus.TrayekDetail.Trayek.Name), 1),
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.mutationReview.secondBus.TrayekDetail.Trayek.Name), 1)
              ])
            ]),
            (_ctx.mutationReview.secondBus?.TrayekDetail?.TrayekSubs?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mutationReview.firstBus.TrayekDetail?.TrayekSubs, (data) => {
                          return (_openBlock(), _createElementBlock("li", {
                            style: {"list-style-type":"disc","list-style-position":"inside"},
                            key: data
                          }, _toDisplayString(`${data.DepartureTime.slice(0, 5)} (PP ${data.Order})`), 1))
                        }), 128))
                      ])
                    ]),
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mutationReview.secondBus.TrayekDetail?.TrayekSubs, (data) => {
                          return (_openBlock(), _createElementBlock("li", {
                            style: {"list-style-type":"disc","list-style-position":"inside"},
                            key: data
                          }, _toDisplayString(`${data.DepartureTime.slice(0, 5)} (PP ${data.Order})`), 1))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.mutationReview.firstBus.TrayekDetail.Trayek.MsClass.Name), 1),
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.mutationReview.secondBus.TrayekDetail.Trayek.MsClass.Name), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.mutationReview.secondBus.Nopol), 1),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.mutationReview.secondBus.TrayekDetail.Trayek.Name), 1),
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.mutationReview.firstBus.TrayekDetail.Trayek.Name), 1)
              ])
            ]),
            (_ctx.mutationReview.secondBus?.TrayekDetail?.TrayekSubs?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mutationReview.secondBus.TrayekDetail?.TrayekSubs, (data) => {
                          return (_openBlock(), _createElementBlock("li", {
                            style: {"list-style-type":"disc","list-style-position":"inside"},
                            key: data
                          }, _toDisplayString(`${data.DepartureTime.slice(0, 5)} (PP ${data.Order})`), 1))
                        }), 128))
                      ])
                    ]),
                    _hoisted_34,
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mutationReview.firstBus.TrayekDetail?.TrayekSubs, (data) => {
                          return (_openBlock(), _createElementBlock("li", {
                            style: {"list-style-type":"disc","list-style-position":"inside"},
                            key: data
                          }, _toDisplayString(`${data.DepartureTime.slice(0, 5)} (PP ${data.Order})`), 1))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.mutationReview.secondBus.TrayekDetail.Trayek.MsClass.Name), 1),
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.mutationReview.firstBus.TrayekDetail.Trayek.MsClass.Name), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _hoisted_42,
        _createElementVNode("div", null, _toDisplayString(_ctx.mutationReview.description), 1)
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _createVNode(_component_Button, {
            class: "btn-back w-full mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.prevPage()))
          }, {
            default: _withCtx(() => [
              _hoisted_45
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createVNode(_component_Button, {
            class: "btn-primary w-full mr-1",
            onClick: _ctx.showDialogConfirmation
          }, {
            default: _withCtx(() => [
              _hoisted_47
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _createVNode(_component_HjpModalDefault, {
      show: _ctx.isShowAlertDialog,
      onHideDialog: _ctx.hideDialogForm
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("img", {
            src: _ctx.attrModalConfirmation.imgContent
          }, null, 8, _hoisted_49)
        ]),
        _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.attrModalConfirmation.title), 1),
        _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.attrModalConfirmation.subTitle), 1),
        _createElementVNode("div", _hoisted_52, [
          _createVNode(_component_Button, {
            type: "submit",
            class: "btn-primary mb-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideDialogForm()))
          }, {
            default: _withCtx(() => [
              _hoisted_53
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show", "onHideDialog"]),
    _createVNode(_component_ConfirmModal2, { ref: "refConfirmModal" }, null, 512)
  ], 64))
}